<template>
  <div id="stars-map" class="work-page" :class="{ 'plate-active' : isPlatesActive, 'string-active': isStringActive, 'loaded': isLoaded, 'detail-loaded' : isDetailVisible,'string-hide' : stringHide, 'resizing': resizeTimeout, 'zoomed': isZoomed, 'work-page-loaded': isPageLoaded, 'work-library-modal': showModal }" @click="closeWorkShare">
    <div class="work__bg-wrap">
      <div class="work__bg">
        <img src="/assets/img/layout/bg-overview.jpg" class="work__bg-img"  alt="work background image">
      </div>
    </div>
    <div class="detail__bg" style="background-image: url('/assets/img/stars-map/bg-info.jpg')"></div>
    <div class="container container--stars-map" >
      <div class="page__top">
        <h1 class="page-top__title">{{ $t('star-map.title') }}</h1>
        <p class="page-top__text">Astronomicum Caesareum<br>
          (Apian, 1540)</p>
      </div>
      <main class="main main--stars-map">
        <div  class="work-content work-content--stars-map work-intro-ani-in">
          <div class="plates-wrap " :style="'margin-top:' + workPosLive + 'px'">
            <div class="plate-bg scale-item" :style="'height:'+ plateWidthLive +'px; width:'+ plateWidthLive +'px'">
              <svg version="1.1" class="plate-bg__img" preserveAspectRatio="xMaxYMin meet" xmlns="http://www.w3.org/2000/svg" x="0" y="0" viewBox="0 0 2168 2835" xml:space="preserve">
                                <defs>
                                    <clipPath id="clip_plate-bg">
                                      <path fill-rule="evenodd" clip-rule="evenodd" d="M675 683s-36.7-28.8-12-55c15.8-16.8 34-1 34-1s7.3-2.3 12 4 25 23 25 23l29-1s56.7-23.4 72-36c0 0 22.9-10.2 44 1 0 0 23-41.4 47-63 0 0 9.4-17.5 32-24 0 0 19.8-15.3 82-27 0 0-12.1-9-11-21s8.6-20.6 15-23v-2s-18.5-3.4-18-34c0 0 5-33.4 31-36 0 0-3.7-5.1 3-6v-23h-26s-7 .5-7-4v-1h-2v-8h-5s.4.9-7 1l-4-1h-3s-3.1-2.8-3-8 4-8 4-8 11.8-8.9 19-9 4 0 4 0-1.9-2.2-2-5c-.1-2.9 3-5 3-5l6-4h1v-1h-1l-4-4s-4-5.6-4-9-.2-8 2-8v-4s2.7-5.4 12-13c0 0 1-.3 1-2v-15s-5.6-.7-1-7v-2s-13.1-23.2-29-32c0 0-4-.5-1 4s5 8 5 8 1.1 1 1 2 0 10 0 10-1.2 0-1 3-.3 4.7 1 5v8l-6 7s-4.9 1.2-5 3 .8 4-3 7c0 0-.1 17.6-3 24-2.6 5.8-7.8 13.3-14 17-6.6 4-14.2 8.3-20 10-4.4 1.3-14.5 4.7-25 1s-21.3-10.3-32-23c0 0-7-7.7-8-32 0 0-.2-26.4 10-41s19.5-27 35-34c0 0 14.4-6.6 41-6 0 0 18.6-.5 28 9 0 0 5.2 2.5 1-2-4.4-4.7-9.7-8.1-12-15s-4.1-13.2-4-17 1-18.8 6-25c0 0 1-1.9-4-2-4-.1-3.9.1-4-2h-10s-3.2 8.9-12 9c0 0-3 .1-3-2s-4-2.5-4 0c0 0-.7 4-9 4 0 0-8.3.8-11-6-1.7-4.3-3 0-3 0s-1.1 5-7 5h-9s-1.8.7-5-7c-1-2.4-1.7-.4-2 0-.3.4-2.6 6-9 6s-9-4-9-4 .9 7-6 8c0 0-4.8 18.4-10 23-5.5 4.9-6.2 6.9-18 10 0 0-8.5.9-10 0s-5.1-3-5-8-2-5-2 0c0 0-1.5 6-8 6h-8s-4.1-2.6-4 1c.1 3.6 1.3 6.7-2 9 0 0-.4 1.9 1 2 0 0 5.3 3.3 1 6 0 0-.9 1.6 1 2 0 0 6.2 3.6 6 10 0 0 1.2 4.4-3 7-4.2 2.6-1.9 6.1-2 7-.2 3.1-4 6-4 6s-8.6 8-13 8h-23s-6.2.5-7-2c0 0 .7-1-7-1 0 0-3.6.3-11-10 0 0-6.9-7.4-7 2 0 0 0 4.1 1 4v5l-7 5s-1.9 7.7-8 7-13.6-1.4-14-6c-.4-4.6-.7-8.2 0-9 .7-.8 3.3-2.9 7-3 3.7-.1 7 .8 8 2s1 3 3 3 4.2.2 5-1h2v-12s1.9-1.1 0-2v-2h-2s-2.5-4.6 0-7c2.5-2.4 2.8-2.5 1-4v-8s3.8-4.1 8-4c4.2.1 1.8-1 1-1s-9-19.3-6-25c2-3.9 0-3.6 0-4-.2-3.9 2.8-9 7-15s10-13 10-13v-2h-3v-1h2s-2.1-13 12-15c0 0 2.4.1 3 3h1v-3l11-9s3.4-.4 1-2v-3l5-4s1-.5 1-2 1-2 1-2v-5s-7.1-5.9-10 0h-2v-2h1v-7s2-2.1 2-3-.3-3 1-3h10v-3h3v-1h1s1.5-4-2-4-7.9-.1-8 3h-2v-3s.6-4.1 7-4 7 0 7 0h3s1.3.3 4-2 1.6-1 4-1 2-3 2-3 1.6-4.9 27-6h4s4.3-6 11-11 16.2-3.7 17-3c.8.7 7 2 7 2s9.2-5.6 20-5c0 0 6.9-3 20-3s15.3.2 20 3c0 0-.2-1 3-1h6s1.9.3 3 2 3 1 3 1 .6-.2 3 1 4.4 3.7 5 5c.6 1.3.8 3.7-1 4-1.8.3-1 1-1 1h2v1h1v5s0 2-2 2h-1v2h9s7.3-8.3-1-14c0 0-5.1-2.8 0-3 5.1-.2 10.9 3.8 9 12-1.4 5.8-6 8-6 8s-15.3.5-20-4c-2.3-2.2-7 7-7 7s-12.8 4-1 3c0 0 6.8-1 8 6 0 0-.1 3.1 2 3 2.1-.1 10.6-1 11 4h11s3.8-3.2 6 1h5v6s13.2-14.1 37-11c23.8 3.1 18.2 6.4 30 4 0 0 9.6-3.6 13-1 0 0 4.3 2.7 1 12 0 0-5.2 5.5-8 8s-3.6 4-2 4 5-2 5-2 6.7-1.9 10 0 7 5 7 5l10 8s5.1 4.8 9 10 7.9 15.3 8 15 .2 4.3-5 3c-3.1-.8-3 1-3 1s4.6 27.5-16 51v4s23.6-16 36-16 49 1 49 1 17.3 4 29 13 20.5 16.1 26 29 11.1 22.3 5 42-14 27-14 27-11.5 22.3-47 22-40.2-16-42-18-6.3-12.3-6-22 0-12.2 1-18c0 0-21.9-26.1-8-46 0 0 2.4-3.7-3-1-5.3 2.7-27.1 14.3-31 22 0 0 1.4 9-6 10 0 0-4.3 4.1-3 5s6 4 6 4v4h-2s14 27.9 15 33 6.5 23.5-2 28c0 0-2.7 2.7 2 3 0 0 13.7 8.5 17 10s8.7 11.6 2 13-10 2.5-10 7c0 0-2.9 2-10 2 0 0-3.3 9.1-7 10s-17 1-17 1-4.8.2-5 2 .5 3.1-2 3v2h2s5.4 11.6 6 18l1 5s21 .6 26 30l5 13s4.2 10.6-5 20c-7 7.2-13 6-13 6v3s10.6 9 12 13 .3 19.2-3 23-9 9-9 9v1s34.8 3.3 57 13c22.2 9.7 23 11 23 11s21.2-6.5 29 13c0 0 44 17.9 56 62 0 0 4.1.5 5 9 .5 4.5 3 0 3 0s2.7-3.5 4-3-.4-1.8 0-3 4.9-5 6-5 4.4.6 5 0 4.2-3.7 7-4 6.2-1.1 9 0 10.2 4.9 12 6 4.4 3.8 7 6 12 11.8 13 13 8.4 8.5 10 10c1.1 1 6 4 6 4s4.3 4.5 6 5 3.4.3 6 2 5.4 3 8 5 6 3.5 8 4 6.1 3.7 8 4 2.7 1.2 3 3 6 0 6 0 4.6 1 7-1 3.3-1.6 5-2 5 1.1 6-7 16.1-10.3 17-11 2.2-1.3 2-5 4-5 4-5 2.1-1.8 3-5 4.7-4 11-3c3.8.6 5-1 5-1s5.8-2.1 13 1 14.7 5.1 19 21 1.5 22.6 1 26c0 0-6.7 7.6-9 9v6h11s7.1-.4 3 4l-821-4z"/>
                                      <path fill-rule="evenodd" clip-rule="evenodd" d="M1509 687l605 609 1 869-601 618-859 11S85.4 2217.2 51 2170c0 0-.8-865.4-2-871 0 0 424.2-460.3 592-620l868 8z"/>
                                        </clipPath>
                                    </defs>
                <image clip-path="url(#clip_plate-bg)" xlink:href="/assets/img/stars-map/bg-plate.jpg" width="2168" height="2835" />
                            </svg>
              <svg version="1.1" class="plate-bg__img img--blur" preserveAspectRatio="xMaxYMin meet" xmlns="http://www.w3.org/2000/svg" x="0" y="0" viewBox="0 0 2168 2835" xml:space="preserve">
                                <defs>
                                    <clipPath id="clip_plate-bg-blur">
                                      <path fill-rule="evenodd" clip-rule="evenodd" d="M675 683s-36.7-28.8-12-55c15.8-16.8 34-1 34-1s7.3-2.3 12 4 25 23 25 23l29-1s56.7-23.4 72-36c0 0 22.9-10.2 44 1 0 0 23-41.4 47-63 0 0 9.4-17.5 32-24 0 0 19.8-15.3 82-27 0 0-12.1-9-11-21s8.6-20.6 15-23v-2s-18.5-3.4-18-34c0 0 5-33.4 31-36 0 0-3.7-5.1 3-6v-23h-26s-7 .5-7-4v-1h-2v-8h-5s.4.9-7 1l-4-1h-3s-3.1-2.8-3-8 4-8 4-8 11.8-8.9 19-9 4 0 4 0-1.9-2.2-2-5c-.1-2.9 3-5 3-5l6-4h1v-1h-1l-4-4s-4-5.6-4-9-.2-8 2-8v-4s2.7-5.4 12-13c0 0 1-.3 1-2v-15s-5.6-.7-1-7v-2s-13.1-23.2-29-32c0 0-4-.5-1 4s5 8 5 8 1.1 1 1 2 0 10 0 10-1.2 0-1 3-.3 4.7 1 5v8l-6 7s-4.9 1.2-5 3 .8 4-3 7c0 0-.1 17.6-3 24-2.6 5.8-7.8 13.3-14 17-6.6 4-14.2 8.3-20 10-4.4 1.3-14.5 4.7-25 1s-21.3-10.3-32-23c0 0-7-7.7-8-32 0 0-.2-26.4 10-41s19.5-27 35-34c0 0 14.4-6.6 41-6 0 0 18.6-.5 28 9 0 0 5.2 2.5 1-2-4.4-4.7-9.7-8.1-12-15s-4.1-13.2-4-17 1-18.8 6-25c0 0 1-1.9-4-2-4-.1-3.9.1-4-2h-10s-3.2 8.9-12 9c0 0-3 .1-3-2s-4-2.5-4 0c0 0-.7 4-9 4 0 0-8.3.8-11-6-1.7-4.3-3 0-3 0s-1.1 5-7 5h-9s-1.8.7-5-7c-1-2.4-1.7-.4-2 0-.3.4-2.6 6-9 6s-9-4-9-4 .9 7-6 8c0 0-4.8 18.4-10 23-5.5 4.9-6.2 6.9-18 10 0 0-8.5.9-10 0s-5.1-3-5-8-2-5-2 0c0 0-1.5 6-8 6h-8s-4.1-2.6-4 1c.1 3.6 1.3 6.7-2 9 0 0-.4 1.9 1 2 0 0 5.3 3.3 1 6 0 0-.9 1.6 1 2 0 0 6.2 3.6 6 10 0 0 1.2 4.4-3 7-4.2 2.6-1.9 6.1-2 7-.2 3.1-4 6-4 6s-8.6 8-13 8h-23s-6.2.5-7-2c0 0 .7-1-7-1 0 0-3.6.3-11-10 0 0-6.9-7.4-7 2 0 0 0 4.1 1 4v5l-7 5s-1.9 7.7-8 7-13.6-1.4-14-6c-.4-4.6-.7-8.2 0-9 .7-.8 3.3-2.9 7-3 3.7-.1 7 .8 8 2s1 3 3 3 4.2.2 5-1h2v-12s1.9-1.1 0-2v-2h-2s-2.5-4.6 0-7c2.5-2.4 2.8-2.5 1-4v-8s3.8-4.1 8-4c4.2.1 1.8-1 1-1s-9-19.3-6-25c2-3.9 0-3.6 0-4-.2-3.9 2.8-9 7-15s10-13 10-13v-2h-3v-1h2s-2.1-13 12-15c0 0 2.4.1 3 3h1v-3l11-9s3.4-.4 1-2v-3l5-4s1-.5 1-2 1-2 1-2v-5s-7.1-5.9-10 0h-2v-2h1v-7s2-2.1 2-3-.3-3 1-3h10v-3h3v-1h1s1.5-4-2-4-7.9-.1-8 3h-2v-3s.6-4.1 7-4 7 0 7 0h3s1.3.3 4-2 1.6-1 4-1 2-3 2-3 1.6-4.9 27-6h4s4.3-6 11-11 16.2-3.7 17-3c.8.7 7 2 7 2s9.2-5.6 20-5c0 0 6.9-3 20-3s15.3.2 20 3c0 0-.2-1 3-1h6s1.9.3 3 2 3 1 3 1 .6-.2 3 1 4.4 3.7 5 5c.6 1.3.8 3.7-1 4-1.8.3-1 1-1 1h2v1h1v5s0 2-2 2h-1v2h9s7.3-8.3-1-14c0 0-5.1-2.8 0-3 5.1-.2 10.9 3.8 9 12-1.4 5.8-6 8-6 8s-15.3.5-20-4c-2.3-2.2-7 7-7 7s-12.8 4-1 3c0 0 6.8-1 8 6 0 0-.1 3.1 2 3 2.1-.1 10.6-1 11 4h11s3.8-3.2 6 1h5v6s13.2-14.1 37-11c23.8 3.1 18.2 6.4 30 4 0 0 9.6-3.6 13-1 0 0 4.3 2.7 1 12 0 0-5.2 5.5-8 8s-3.6 4-2 4 5-2 5-2 6.7-1.9 10 0 7 5 7 5l10 8s5.1 4.8 9 10 7.9 15.3 8 15 .2 4.3-5 3c-3.1-.8-3 1-3 1s4.6 27.5-16 51v4s23.6-16 36-16 49 1 49 1 17.3 4 29 13 20.5 16.1 26 29 11.1 22.3 5 42-14 27-14 27-11.5 22.3-47 22-40.2-16-42-18-6.3-12.3-6-22 0-12.2 1-18c0 0-21.9-26.1-8-46 0 0 2.4-3.7-3-1-5.3 2.7-27.1 14.3-31 22 0 0 1.4 9-6 10 0 0-4.3 4.1-3 5s6 4 6 4v4h-2s14 27.9 15 33 6.5 23.5-2 28c0 0-2.7 2.7 2 3 0 0 13.7 8.5 17 10s8.7 11.6 2 13-10 2.5-10 7c0 0-2.9 2-10 2 0 0-3.3 9.1-7 10s-17 1-17 1-4.8.2-5 2 .5 3.1-2 3v2h2s5.4 11.6 6 18l1 5s21 .6 26 30l5 13s4.2 10.6-5 20c-7 7.2-13 6-13 6v3s10.6 9 12 13 .3 19.2-3 23-9 9-9 9v1s34.8 3.3 57 13c22.2 9.7 23 11 23 11s21.2-6.5 29 13c0 0 44 17.9 56 62 0 0 4.1.5 5 9 .5 4.5 3 0 3 0s2.7-3.5 4-3-.4-1.8 0-3 4.9-5 6-5 4.4.6 5 0 4.2-3.7 7-4 6.2-1.1 9 0 10.2 4.9 12 6 4.4 3.8 7 6 12 11.8 13 13 8.4 8.5 10 10c1.1 1 6 4 6 4s4.3 4.5 6 5 3.4.3 6 2 5.4 3 8 5 6 3.5 8 4 6.1 3.7 8 4 2.7 1.2 3 3 6 0 6 0 4.6 1 7-1 3.3-1.6 5-2 5 1.1 6-7 16.1-10.3 17-11 2.2-1.3 2-5 4-5 4-5 2.1-1.8 3-5 4.7-4 11-3c3.8.6 5-1 5-1s5.8-2.1 13 1 14.7 5.1 19 21 1.5 22.6 1 26c0 0-6.7 7.6-9 9v6h11s7.1-.4 3 4l-821-4z"/>
                                      <path fill-rule="evenodd" clip-rule="evenodd" d="M1509 687l605 609 1 869-601 618-859 11S85.4 2217.2 51 2170c0 0-.8-865.4-2-871 0 0 424.2-460.3 592-620l868 8z"/>
                                        </clipPath>
                                    </defs>
                <image clip-path="url(#clip_plate-bg-blur)" xlink:href="/assets/img/stars-map/bg-plate.jpg" width="2168" height="2835" />
                            </svg>
            </div>
            <div class="plate-wrap scale-item">
              <div class="plate" id="rotator" :style="'height:'+ plateWidthLive +'px; width:'+ plateWidthLive +'px'">

                <svg version="1.1" class="plate__img" preserveAspectRatio="xMaxYMin meet" xmlns="http://www.w3.org/2000/svg" x="0" y="0" viewBox="0 0 2168 2168" xml:space="preserve">
                                    <defs>
                                        <clipPath id="clip_plate">
                                            <path d="M842 138s311.5-94.4 648 65l52-24s.4-1.8 6 0 12 0 12 0 3.6.2 1 6-22 43-22 43 141.7 70.1 236 175c94.3 104.9 98.7 105.8 163 219 0 0 33.6 5.9 39 13 0 0 4 2.4 5-2 0 0 3.6 3.6 6 3s6 4 6 4 4.7.2 5 7c.2 4.2 2 4 2 4h3s5.4 2.8 0 5c-5.9 2.4-41.8 16.5-44 20 0 0 36.4 81.1 45 109 8.6 27.9 27.9 98 34 137 3.2 20.3 9.9 46.9 10 115 .1 68.1-6.9 165.8-8 176-1.2 10.9-7 43-7 43s-2.7 5.2 1 4c0 0 1.5-7.3 8 1 0 0-.2 5.6-3 6 0 0 2.7 2.6 4 5 1.3 2.5 7.1 12.7 13 17 0 0 8.9 3.2 5 10 0 0-2.2 6.1 0 7 2.2.9 0 5 0 5s-.4 11 2 14 2.3 3.9-3 3c-5.3-.9-7 1.2-7 1 0-.2-3.3.4-4 0-.7-.4-7.4-7.1-29-9 0 0-5-1.6-1 7s.6 3.9-1 6v7s1.4 2.2-3 6l-6 17s-1.8 5.8-5 15c-3.3 9.4-6 17-6 17l-8 20-24 56s-42.3 84.5-55 102c-12.7 17.5-27.8 51.4-57 86 0 0-51.5 72.8-99 114 0 0-16.9 24.8-119 104 0 0 5.8 9.9 2 17s-12 22-12 22-1.6 3.4 0 7c.9 2.1-10 11-10 11s-2.7 2.8-4 0c-1.3-2.8-19-30-19-30s-21.6 18.6-65 41-181.5 87.5-286 105-236.6 24.1-349 0-223.6-71-303-117l-80-54s-3.6-3-8 0-18 3-18 3-3.8-1.4-9 3-11.1 4.4-12 4c-2-.9-19-14-19-14v-4h3s1.9-4.3 3-6c1.1-1.7 6-7 6-7l11-11-4-4v-1s-123.8-101.8-205-243l-40 33s-9.9-4-10-13c-.1-9 0-45 0-45l5-8s-3-38.5 6-40c0 0-71.7-158.3-74-202 0 0-35.1-194.2-27-290 8.1-95.8 12.9-190.9 75-338s158.3-260.6 197-295c0 0 79.4-95.7 265-193 0 0 107.2-52.5 129-52 0 0 1-18 11-25 0 0 4.1-.3 6-18 0 0 18.3-18.3 28-18l10 43s-.3 1.5 2 0z" fill-rule="evenodd" clip-rule="evenodd"/>

                                        </clipPath>
                                        </defs>
                  <image clip-path="url(#clip_plate)" xlink:href="/assets/img/stars-map/plate.jpg" width="2168" height="2168" />
                                </svg>

                <div class="plate__handle-track">
                  <div class="plate__handle">
                    <span class="sicon sicon__slide-handle" aria-hidden="true"></span>
                    <span class="visuallyhidden">Slide Handle</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="stars__legend" v-if="!isDetailVisible">
            <div class="stars-legend__item" :class="{ 'active' : isPlatesActive }" ><p class="blue">{{ $t('Sternscheibe') }} (Octavae Sphaerae)</p><p>{{ $t('Grundscheibe') }} (Mater)</p></div>
            <div class="stars-legend__item" :class="{ 'active' : isStringActive }"><p class="blue">{{ $t('Messhilfe (Faden)') }}</p></div>
          </div>

        </div>

        <detail v-on:show-modal="showModalMsg"></detail>
      </main>
    </div>
    <div id="string-interactive">
      <div class="string__handle scale-item">
        <span class="sicon sicon__string-handle" aria-hidden="true"></span>
        <span class="visuallyhidden">Slide Handle</span>
      </div>
      <div class="string-canvas-wrap" :class="{ 'active' : isStringActive }"><canvas id="string-canvas"  /></div>
    </div>
    <menuprimary current-nav="star-map" :needNavprojects=true  v-on:toggle-detail="toggleDetail"></menuprimary>
    <div class="top-tool-nav-wrap">
      <div @click="toggleDetail" v-if="isDetailVisible" class="btn-close-circle" aria-hidden="true">
        <span class="visuallyhidden">close detail content</span>
      </div>
      <share-section v-if="isDetailVisible"></share-section>
      <router-link to="overview" class="btn-close-circle" aria-hidden="true" v-else>
        <span class="visuallyhidden">go to overview page</span>
      </router-link>
      <router-link to="zoom-star-map" class="zoom-btn">
        <span class="sicon sicon__zoom-more" aria-hidden="true"></span>
        <span class="visuallyhidden">Link zu zoomed img</span>
      </router-link>
    </div>
    <modal v-if="showModal" url="https://www.e-rara.ch/zut/content/pageview/2434912" @close="showModal=false"></modal>
  </div>
</template>

<script>
  import iStarsMap from '../info/i-stars-map';
  import Modal from '../../components/modal';
  import MenuPrimary from '../../components/menu-primary';
  import Slides from '../../data/planet-slides';
  import ShareSection from '../../components/share';

  import anime from 'animejs';
  import Hammer from '../../assets/js/hammer.min';

  export default {
    name: 'starmapComponent',
    components: {
      'detail': iStarsMap,
      'modal': Modal,
      'menuprimary': MenuPrimary,
      'share-section': ShareSection
    },
    data() {
      return {
        outdeg: 0,
        indeg: 0,
        isPlatesActive: false,
        isStringActive: false,
        isLoaded: false,
        showModal: false,
        isDetailVisible: false,
        stringHide: true,
        rotateAngle: 0,
        windowWidth: window.innerWidth,
        windowHeight:window.innerHeight,
        plateWidthLive:'',
        plateBgHeightLive:'',
        workPosLive:'',
        slides: Slides.data()['Slides'],
        ropeHandle:'',
        sim:'',
        old:'',
        canvas:'',
        ctx:'',
        canvasW:0,
        canvasH:0,
        rtime:'',
        resizeTimeout: false,
        resizeDelay: 200,
        isZoomed:false,
        zoomEl:'',
        workEl:'',
        rotateEl:'',
        propellerInstanz:'',
        lastWindowW:'',
        lastWindowH:'',
        isPageLoaded: false,
        instAniInterval: null,
        instAniLoadTimer: null,
        pageLoadTimer: null,
        initRopeTimer: null,
        mouse: {x:0, y: 0},
        pageTop:'',
        tangent: 0,
      }
    },
    created() {
      this.isMobile = this.mobileAndTabletcheck()
    },
    methods: {
      instractionAni: function () {
        var step = 0;
        var deg = 5;
        var dist = this.plateWidthLive / 50;
        var _this = this;

        this.instAniInterval = setInterval(frame, 75);

        function frame() {

          if (step >= 30 || _this.isDetailVisible) {
            _this.isStringActive = false
            _this.isPlatesActive = false
            _this.clearIntervalInstAni()
          } else {
            if(step == 0) {
              _this.isPlatesActive = true
              _this.isStringActive = false
              var val = 360 - deg;
              _this.propellerInstanz.angle = val
            }
            else if((step >= 5 && step < 10)|| (step >= 15 && step < 20)) {
               val = _this.propellerInstanz.angle + deg;
              _this.propellerInstanz.angle = val

            } else if(step < 5 || step >=10 && step < 15) {
               val = _this.propellerInstanz.angle - deg;
              _this.propellerInstanz.angle = val
            } else if(step >= 20) {
              _this.isPlatesActive = false
              _this.isStringActive = true
              var ropeRect = _this.ropeHandle.getBoundingClientRect()

              if(step < 30) {
                _this.moveRopeByJs(ropeRect.left, ropeRect.top - dist )
              }
            }
          }
          step++;
        }
      },
      clearIntervalInstAni : function() {
        if(this.instAniInterval) {
          clearInterval(this.instAniInterval);
        }
      },
      stringHandleOnPress: function() {
        // eslint-disable-next-line no-undef
        gtag('event', 'moveString', {
          'event_category' : 'star-map',
          'event_label' : 'star-map',
        });
        this.isStringActive = true
      },
      stringHandleOnPressup: function() {
        this.isStringActive = false
      },
      showModalMsg : function() {
        this.showModal = true
      },

      toggleDetail:function () {
        if(!this.isDetailVisible) {
          // eslint-disable-next-line no-undef
          gtag('config', this.uaId, {'page_path': this.$route.path + '-i-detail'});
        } else {
          // eslint-disable-next-line no-undef
          gtag('config', this.uaId, {'page_path': this.$route.path });

          var audio = this.$el.querySelectorAll('audio')[0];
          if(!audio.paused){
            audio.pause();
          }
        }

        this.isDetailVisible = !this.isDetailVisible

        var _scale = 1;
        var workHTo =  window.innerHeight - this.$el.querySelector('.nav-bottom').clientHeight
        var workMarginTop = 0;

        if(this.isDetailVisible) {
          document.body.classList.add('detail-opened');
          this.resetWorkZoom();
          this.stringHide = true
          _scale = 0.7;
          workHTo = this.plateWidthLive * 0.7 + this.workPosLive;
          if(window.innerWidth > window.innerHeight) {
            workMarginTop = 10
          } else {
            workMarginTop = this.pageTop.clientHeight *  0.8;
          }
        } else {
          document.body.classList.remove('detail-opened');
        }

        anime({
          targets: [this.$el.querySelectorAll('.scale-item')],
          scale: _scale,
          duration: 500,
          easing:'easeOutQuart',
          complete: function() {
            window.onresize()
          }
        });
        anime({
          targets: [this.workEl],
          height: workHTo,
          marginTop: workMarginTop,
          duration: 500,
          easing:'easeOutQuart'
        });

      },
      resizeWorkDetail: function() {
        var work = this.workEl;

        if(this.isDetailVisible) {
          work.style.height =  this.plateWidthLive * 0.7 + this.workPosLive + 'px';
          if(window.innerWidth > window.innerHeight) {
            //console.log('landscape')
            work.style.marginTop = '10px'
          } else {
            // console.log('portrait')
            work.style.marginTop = this.pageTop.clientHeight *  0.8 + 'px';
          }
        }
      },
      // Thus function returns if point is outside circle
      outsideCircle: function( centerX, centerY, radius, currentX, currentY) {
        var r = false;
        let val = Math.pow((currentX - centerX), 2) + Math.pow((currentY - centerY), 2);

        // Outside circle
        if (val > Math.pow(radius, 2)) {
          r = true;
        }

        return r;
      },
      getPlateWidth: function() {
      var navBottomEl = this.$el.querySelector('.nav-bottom'),
          paddingLeft = parseInt(window.getComputedStyle(this.pageTop).getPropertyValue('padding-left')),
          workH = this.windowHeight - navBottomEl.clientHeight,
          availH = workH - this.pageTop.clientHeight + this.$el.querySelector('.page-top__text').clientHeight,
          _bottomNav = parseInt(window.getComputedStyle(navBottomEl).getPropertyValue('bottom')),
          ratio = 250 / 400;

        if(window.innerWidth < 1025){
          availH = workH - this.pageTop.clientHeight;
        }

        if(!this.isDetailVisible) {
          this.workEl.style.height = workH + 'px';
        }
        if(_bottomNav  > 0) {
          availH = availH - _bottomNav
        }

        if(availH < 250) {
          availH = 250
        }
        var mustW = availH * ratio,
          availW = this.windowWidth - paddingLeft * 2,
          maxAailW = Math.min(mustW, availW);
        this.plateWidthLive = maxAailW
        this.workPosLive = maxAailW * (1 - ratio)
      },
      resetWorkZoom : function() {
        this.isZoomed = false
        var transform =
          "translate3d(0, 0, 0) " +
          "scale3d(1, 1, 1)";

        this.zoomEl.style.transform = transform;
        this.zoomEl.style.webkitTransform = transform;
      },
      plateRotation: function () {
        var rotateEl = this.rotateEl;
        var _this = this;

        // eslint-disable-next-line no-undef
        this.propellerInstanz = new Propeller(rotateEl,  {
          inertia: 0,
          speed: 0,
          onDragStart: function() {
            // eslint-disable-next-line no-undef
            gtag('event', 'plateRotation', {
              'event_category' : 'star-map',
              'event_label' : 'star-map',
            });
            _this.isPlatesActive = true;
            _this.clearIntervalInstAni()
          },
          onDragStop: function() {
            _this.isPlatesActive = false
          }
        });
      },
      tangentRope: function (centerX,centerY,ropeX,ropeY){
        /* we need to get the tangent degrees for the zoom*/
        /* get length for triangle: side B */
        if(ropeX > centerX){
          var sideB = ropeX - centerX;
        } else {
          sideB = centerX - ropeX;
        }

        /* get height for triangle: side A */
        if(ropeY > centerY){
          var sideA = ropeY - centerY;
        } else {
          sideA = centerY - ropeY;
        }

        this.tangent = sideA / sideB;
      },
      createRope: function () {
        //let elWidth = this.ropeHandle.offsetWidth;
        //let posXDefault = this.ropeHandle.offsetLeft;
        //let posYDefault = this.ropeHandle.offsetTop;

        this.sim =  new this.Sim()
        this.old = new Date().getTime()
        this.canvas = this.$el.querySelector('#string-canvas')
        this.ctx = this.canvas.getContext('2d')
        this.canvasW = this.canvas.width = this.windowWidth
        this.canvasH = this.canvas.height = this.windowHeight - 80
      },
      moveRopeByJs: function (_x,_y) {
        //let lastPosX = this.ropeHandle.offsetLeft;
        //let lastPosY = this.ropeHandle.offsetTop;
        let ropeHandleCenter = this.ropeHandle.offsetWidth / 2;
        let posX = _x;
        let posY = _y;
        let plateWidthRange = this.plateWidthLive * 1.1 - (this.ropeHandle.offsetWidth * 2);
        let platePosX = (this.windowWidth - plateWidthRange) / 2;
        let platePosY = (this.windowHeight - plateWidthRange) / 2;

        //boundaries : 80 is
        posX = posX  < 0 ? 0 : posX;
        posX = posX - this.ropeHandle.offsetWidth < platePosX ? platePosX - this.ropeHandle.offsetWidth : posX;
        posX = posX > plateWidthRange + platePosX ? (plateWidthRange + platePosX) : posX;

        posY = posY < platePosY ? platePosY - this.ropeHandle.offsetWidth : posY;
        posY = posY > plateWidthRange + platePosY ? (plateWidthRange + platePosY) : posY;

        this.ropeHandle.style.left = posX + 'px';
        this.ropeHandle.style.top = posY + 'px';

        this.mouse.x = posX + ropeHandleCenter;
        this.mouse.y = posY + ropeHandleCenter;

        this.ropeStep()
      },
      initRope: function () {
        if(this.isDetailVisible) {
          this.stringHide = true
        } else {
          this.stringHide = false
        }

        this.createRope();

        var sim = this.sim

        var plateRect = this.$el.querySelector('.plate').getBoundingClientRect(),
          plateBottom = plateRect.height + plateRect.top,
          plateCenterY = plateRect.top + (plateRect.height / 2),
          plateCenterX = plateRect.left + plateRect.width / 2,
          ropeLength = Math.round((plateRect.width / 2 - this.ropeHandle.offsetWidth ) / 10 ) * 10,
          ropeHandleCenter = this.ropeHandle.offsetWidth / 2,
          ropeLengthDesktop = 90;

          if(localStorage.getItem('volvelle-tangent')){
            ropeLengthDesktop = 80;
          }

        // step = distance between dots
        // length = rope length
        var op,
          mouse,
          anchor,
          step = 10,
          length = ropeLength > 120 ? ropeLengthDesktop : ropeLength;


        if(window.innerWidth < 768){
          length = 50;
        }

        var count = length / step;

        for (var i = 0; i < count; ++i) {

          //rope dots starting point -> start form center of window width, bottom of plate position
          var np = new this.Particle(window.innerWidth / 2, plateBottom,  10.1);

          sim.particles.push(np);

          if (i > 0) sim.springs.push(new this.Spring(np, op, step,1.5));

          op = np;
        }

        // Fix the first particle
        anchor = sim.particles[0];
        anchor.fixed = true;
        anchor.x = plateCenterX;
        anchor.y = plateCenterY;

        //set handle start position
        if(localStorage.getItem('starMap-string-left')){
          if(!localStorage.getItem('starMap-orientationchange')){
            this.ropeHandle.style.top = parseFloat(localStorage.getItem('starMap-string-top')) + 'px';
            this.ropeHandle.style.left = parseFloat(localStorage.getItem('starMap-string-left')) + 'px';
          } else {
            this.ropeHandle.style.top = plateCenterY + (plateRect.width * 0.2) + 'px'; //20% to right from center
            this.ropeHandle.style.left = plateCenterX + (plateRect.width * 0.2) + 'px'; //20% to bottom from center
          }

          setTimeout(function (){
            localStorage.removeItem('starMap-center-y');
            localStorage.removeItem('starMap-string-top');
            localStorage.removeItem('starMap-string-left');
            localStorage.removeItem('starMap-tangent');
            localStorage.removeItem('starMap-orientationchange');
          },20);

        } else {
          this.ropeHandle.style.top = plateCenterY + (plateRect.width * 0.2) + 'px'; //20% to right from center
          this.ropeHandle.style.left = plateCenterX + (plateRect.width * 0.2) + 'px'; //20% to bottom from center
        }

        // Move last particle with mouse
        mouse = sim.particles[count - 1];
        mouse.fixed = true;
        mouse.x = this.ropeHandle.offsetLeft + ropeHandleCenter;
        mouse.y = this.ropeHandle.offsetTop + ropeHandleCenter;

        this.tangentRope(plateCenterX,plateCenterY,(this.ropeHandle.offsetLeft + ropeHandleCenter),(this.ropeHandle.offsetTop + ropeHandleCenter));


        this.mouse = mouse;

        const ropeStage = this.$el.querySelector("#string-interactive");
        const mc = new Hammer.Manager(ropeStage);
        mc.add( new Hammer.Pan({ direction: Hammer.DIRECTION_ALL}) );
        mc.add( new Hammer.Tap());
        mc.add( new Hammer.Press({ time: 50} ) );
        mc.domEvents = true
        mc.on('press', (e) => {
          this.clearIntervalInstAni()
          if(e.target == this.ropeHandle) {
            this.stringHandleOnPress(e)
          }
        });
        mc.on('pressup', (e) => {
          if(this.isStringActive) {
            this.stringHandleOnPressup(e)
          }
        });

        let isDragging = false;
        //let lastPosX = 0;
        //let lastPosY = 0;

        mc.on('pan', (e) => {
          this.clearIntervalInstAni()
          if(this.instAniLoadTimer) {
            clearTimeout(this.instAniLoadTimer);
          }
          if(this.isStringActive ) {
            if ( ! isDragging ) {
              isDragging = true;
              //lastPosX = this.ropeHandle.offsetLeft;
              //lastPosY = this.ropeHandle.offsetTop;
            }

            let posX = e.center.x - ropeHandleCenter;
            let posY = e.center.y - ropeHandleCenter;
            let radius = (this.plateWidthLive * 1.1) / 2;



            //boundaries : 80 is
            posX = posX  < 0 ? 0 : posX;

            if(this.outsideCircle(plateCenterX,plateCenterY, radius, posX, posY)){
              var posAlphaY = plateCenterY - posY;
              var posAlphaX =  plateCenterX - posX;

              let alpha = (Math.atan2(posAlphaY, posAlphaX * -1) * 180 / Math.PI + 360) % 360;

              var maxX = Math.abs(radius * Math.cos(alpha / 180 * Math.PI));
              var maxY = Math.abs(radius * Math.sin(alpha / 180 * Math.PI));

              var newPosX = Math.min(Math.max(-maxX, posAlphaX), maxX)
              var newPosY = Math.min(Math.max(-maxY, posAlphaY), maxY)

              posX = -newPosX + plateCenterX;
              posY = -newPosY + plateCenterY;
            }

            this.ropeHandle.style.left = posX + 'px';
            this.ropeHandle.style.top = posY + 'px';


            this.mouse.x = posX + ropeHandleCenter;
            this.mouse.y = posY + ropeHandleCenter;

            this.ropeStep()

            if(e.isFinal) {
              isDragging = false
              this.isStringActive = false
              this.tangentRope(plateCenterX,plateCenterY,(posX + ropeHandleCenter),(posY + ropeHandleCenter));
            }
          }
        })

        var self = this;
        var countTime = 0;
        var initInterval = setInterval(function(){
          ++countTime;
          self.ropeStep()
          if(countTime == 20){
            clearInterval(initInterval);
            self.isLoaded = true
          }
        }, 1);
      },
      ropeStep: function () {
        var old = this.old
        var now = new Date().getTime(),
          delta = now - old;
        var sim = this.sim
        var ctx = this.ctx

        sim.tick(delta);

        // Draw
        ctx.clearRect(0, 0, this.canvasW, this.canvasH);

        var p = sim.particles.length;
        while (p--) {
          var particle = sim.particles[p];
          ctx.beginPath();
          ctx.fillStyle = "transparent";
          //ctx.arc(particle.x, particle.y, 1, 0, false);
          ctx.fillRect(particle.x, particle.y, 1, 1)
          //ctx.fill();
        }

        var s = sim.springs.length;
        while (s--) {
          var spring = sim.springs[s];
          ctx.beginPath();
          ctx.moveTo(spring.p1.x, spring.p1.y);
          ctx.lineTo(spring.p2.x, spring.p2.y);
          ctx.strokeStyle = 'white';
          ctx.lineWidth = 2;
          ctx.shadowColor = '#666';
          ctx.shadowBlur = 4;
          ctx.lineJoin = 'bevel';
          ctx.stroke();
        }
        old = now;
      },
      resizeRope: function () {
        if (new Date() - this.rtime < this.resizeDelay) {
          setTimeout(this.resizeRope, this.resizeDelay);
        } else {
          this.resizeTimeout = false;
          this.initRope();
        }
      },
      pageLoad : function() {
        this.isPageLoaded = true
        var _this = this
        this.pageLoadTimer = setTimeout(function () {
          _this.$el.querySelector(".work-intro-ani-in").classList.remove('work-intro-ani-in')
        }, 1600)
      },
      setPlateRotation: function (){
        this.propellerInstanz.angle = parseFloat(localStorage.getItem('starMap-plate'));

        setTimeout(function (){
          localStorage.removeItem('starMap-plate');
        },10);
      },
    },
    beforeRouteLeave (to, from, next) {
      this.clearIntervalInstAni()
      if(this.instAniLoadTimer) {
        clearTimeout(this.instAniLoadTimer);
      }
      if(this.initRopeTimer) {
        clearTimeout(this.initRopeTimer);
      }
      if(this.pageLoadTimer) {
        clearTimeout(this.pageLoadTimer);
      }
      document.body.classList.remove('detail-opened');
      localStorage.setItem('starMap', '');

      if(to.name == 'zoom-star-map'){
        var plateRect = this.$el.querySelector('.plate').getBoundingClientRect(),
          plateCenterY = plateRect.top + (plateRect.height / 2);
        localStorage.setItem('starMap-plate', this.propellerInstanz.angle);
        localStorage.setItem('starMap-center-y', plateCenterY);
        localStorage.setItem('starMap-string-top', document.querySelector('.string__handle').style.top);
        localStorage.setItem('starMap-string-left', document.querySelector('.string__handle').style.left);
        localStorage.setItem('starMap-tangent', this.tangent);
      } else {
        localStorage.removeItem('starMap-plate');
        localStorage.removeItem('starMap-center-y');
        localStorage.removeItem('starMap-string-top');
        localStorage.removeItem('starMap-string-left');
        localStorage.removeItem('starMap-tangent');
        localStorage.removeItem('starMap-orientationchange');
      }
      this.aniMenuPageLeave(next());
    },
    mounted() {
      this.pageTop = this.$el.querySelector('.page__top');
      this.ropeHandle = this.$el.querySelector('.string__handle');
      this.workEl = this.$el.querySelector(".work-content");
      this.zoomEl = this.workEl;
      this.rotateEl = this.$el.querySelector('#rotator');
      this.saveCurrentPlanetToLocalStorage();
      this.getPlateWidth();
      this.lastWindowW =  window.innerWidth
      this.lastWindowH =  window.innerWidth
      var _this = this

      //due to plate.getBoundingClientRect();
      this.initRopeTimer = setTimeout(_this.initRope, 1500);

      window.onresize = () => {
        this.windowHeight = window.innerHeight
        this.windowWidth = window.innerWidth

        // console.log('window.innerHeight',window.innerHeight);
        if(this.isMobile && this.lastWindowW == window.innerWidth  && this.isDetailVisible) {
          return false
        }

        this.getPlateWidth();
        if(!this.isDetailVisible) {
          this.rtime = new Date();
          if (this.resizeTimeout === false) {
            this.resizeTimeout = true;
            this.isLoaded = false
            setTimeout(this.resizeRope, this.resizeDelay);
          }
        } else {
          this.resizeWorkDetail();
        }
        this.lastWindowW = window.innerWidth
        this.lastWindowH = window.innerHeight
      }

      //	Plates Rotation
      this.plateRotation();
      this.pageLoad();
      this.setWorkBgPos();
      if(!localStorage.getItem('starMap-string-left')) {
        this.instAniLoadTimer = setTimeout(this.instractionAni,2000)
      } else {
        this.setPlateRotation();
        this.isStringActive = false;
        this.isPlatesActive = false;
        this.clearIntervalInstAni();
      }
    }
  }
</script>

